import { render, staticRenderFns } from "./msg7.vue?vue&type=template&id=4f452726&"
import script from "./msg7.vue?vue&type=script&lang=js&"
export * from "./msg7.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports